import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../../settings/const";

export default class LoginWithAppleSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Login With Apple",
            description              : "The Login with Apple module provides a secure and private way for users to sign in using their Apple ID, offering a fast and seamless authentication experience.",
            svgIcon                  : "isvg-apple-auth-integration",
            settingsUrl              : "settings/integrations/apple",
            settingsMenuTopCategory  : SettingsMenuTopCategory.INTEGRATIONS,
            typeLabel                : "Integrations"

        });

        this.parentSection          = SettingsParentSection.INTEGRATIONS
    }

}
